import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class MovieList extends Component{
  render(){
    return(
      <>
      <div className="carousel-cell">
        <div className="movie-list-item">
          <img src={this.props.image} />
        </div>
      </div>
      </>
    );
  }
}

export default MovieList;
